export class ConsumerAmbassadorsProfile {
  id!: string
  userId!: string
  name!: string
  city!: City
  country!: Country
  identityNumber!: string
  genderEnum!: number
  dateOfBirth!: string
  role!: string
  phoneNumber!: any
  phoneExtension!: string
  email!: string
  userstatus!: string
  userImage!: string
  creationDate!: string
  activationDate: any
  suspendedDate: any
  canDelete!: boolean
  canEdit!: boolean
  canUnSuspend!: boolean
  canSuspend!: boolean
  canSendVerification!: boolean
  //
  fullName!: string
  arabicName!: string
  countryKey!: string
  birthdate!: string
  gender!: string
  extention!: string
  countryId!: string
  cityId!: string
  cityName!: string
  countryName!: string
  profilePhoto!: string
  status!: any
  joinedDate: any
  lastLoginDate: any
  userName!: string
  showActivationBtn!: boolean
  showEditBtn!: boolean
  showDeleteBtn!: boolean
  pushNotificationIsEnabled!: boolean
  isVisitor!: boolean
  canEditArabicName!: boolean
  visitor!: any
  canEditType!: boolean
  userAvailability!: any
  userTypeEnum!: any
  canViewMembershipNumberData!: boolean
  membershipNumber!: any
  subscriptionData!: any
  ambassadorLevel!: any
  badges!: any
  canModifyProfileEduAndWrokExericeData!: boolean
  subscriptionTypeEnum!: any
   username!:string
  permissions!:any
  profilePicture!:any
}

export class City {
  id!: number
  name!: string
  code!: any
  description!: any
  isSpecial!: boolean
  icon!: any
}

export class Country {
  id!: number
  name!: string
  code!: any
  description!: any
  isSpecial!: boolean
  icon!: any
}
